import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsSquarespace() {
  return (
    <IntegrationDocTemplate
      title="Squarespace Commerce"
      category="Platform"
      status="beta"
      summary="Squarespace Commerce API v1.0 — products, orders, inventory, profiles. API key auth. Best for boutique brands and DTC stores under 5K orders/month."
      prerequisites={[
        'Squarespace Commerce subscription (Basic, Advanced, or Commerce).',
        'API key from Squarespace dashboard → Settings → Advanced → Developer API Keys.',
        'Scopes: Inventory, Orders, Products, Profiles.',
      ]}
      connectSteps={[
        'Text us "Squarespace" with your phone number.',
        'Generate an API key in your Squarespace dashboard and paste it.',
        'First sync: products + last 30 days of orders + inventory.',
        'Optional: enable webhook subscription for real-time order events.',
      ]}
      syncedData={[
        { type: 'Products', detail: 'Items, variants, options, images' },
        { type: 'Orders', detail: 'Orders + line items + shipping/billing addresses' },
        { type: 'Inventory', detail: 'Per-variant stock quantity' },
        { type: 'Profiles', detail: 'Customer profiles for segmentation' },
      ]}
      agents={[
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
      ]}
      troubleshooting={[
        { question: 'API rate limit (429)', answer: 'Squarespace caps at 60 req/min. Our client uses adaptive backoff; large catalogs sync over multiple minutes.' },
      ]}
      supportLink="/contact"
    />
  );
}
